import { AssetModel } from "@interfaces/index";
import { getAlertTriangleIconStr, getUploadLaterDocsTitle } from "@utils/index";

export const getUploadLaterTooltipContentStr = (
  asset: AssetModel | Omit<AssetModel, "attachments" | "userBusiness">,
  bodyText?: string,
  iconSize: "size_16" | "size_24" = "size_16",
) => {
  let result =
    '<div style="display: flex; align-items: center; column-gap: 4px; font-size: 16px; font-weight: 700; color: #1A1A1A;">';
  result += `${getAlertTriangleIconStr(iconSize)} ${asset.name}`;
  result += "</div>";
  result += bodyText
    ? `<div style="font-size: 12px; line-height: 16px; font-weight: 500; color: #1A1A1A8A; padding-top: 8px">${bodyText}</div>`
    : "";
  result +=
    '<div style="font-weight: 700; padding: 12px 0; color: #1A1A1A;">Required documents:</div>';
  result += '<div style="color: #1A1A1A8A;">';
  result += getUploadLaterDocsTitle(asset);
  result += "</div>";

  return result;
};
